import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage";
import AsyncLock from 'async-lock';
import { Observable, Subject } from "rxjs";

@Injectable()
export class RecentSearchService {

    private lock = new AsyncLock();
    private storageKey: string = 'recent_searches';
    private watcher = new Subject<string[]>();

    constructor(
        private storage: Storage,
    ) {

    }

    public async getAll(): Promise<string[]> {
        let searches = await this.storage.get(this.storageKey);
        if (!searches) return [];
        return searches;
    }

    public add(text: string): Promise<string[]> {
        return this.lock.acquire<string[]>(this.storageKey, async () => {
            let searches = await this.getAll();

            searches = searches.filter(value => value != text);
            searches.push(text);

            await this.storage.set(this.storageKey, searches);

            this.watcher.next(searches);

            return searches;
        });
    }

    public clear(): Promise<void> {
        return this.lock.acquire<void>('recent_searches', async () => {
            await this.storage.remove(this.storageKey);
            return;
        });
    }

    public watch(): Observable<string[]> {
        return this.watcher.asObservable();
    }

}



// WEBPACK FOOTER //
// ./src/providers/recent-search-service.ts